// extracted by mini-css-extract-plugin
export default {"cls1":"qwzrJLNF87DF7JM3RbJR","cls2":"gJ6Ne0i93AJDPMEHk3dv qwzrJLNF87DF7JM3RbJR"};